import { useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

/**
 * @param {*} Text 
 */
export const Text = ({ onChange, label, name, prefix, suffix, type, value = "", minNumber = 0, maxNumber = 999999999999999, disabled }) => {
  const inputRef = useRef();
  const minNumberVerification = type === "number" && minNumber >= 0;
  const maxNumberVerification = type === "number" && maxNumber >= 0;

  const blockInvalidChar = (e) => { 
  ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
  
  if(type === "number"){
    let value = parseInt(e.target.value, 10);
    if (e.key === 'ArrowDown') {
      value -= 1;
      value < minNumber && e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      value += 1
      value > maxNumber && e.preventDefault()
    }    
  }
};

  const handleOnChange = (e, type) => {
    let value = e.target.value;

    switch (type) {
      case 'number':
        if (value < minNumber) e.target.value = minNumber
        if (value > maxNumber) e.target.value = maxNumber

        if (!value || (value >= minNumber && value <= maxNumber)) {
          onChange(e, type)
        }
        break;
    
      default:
        onChange(e, type)
        break;
    }
  }

  const onIncrementClick = (e) => {
    e.preventDefault();

    const value = inputRef.current.valueAsNumber
    const newValue = value + 1
    if(newValue <= maxNumber){
      inputRef.current.value = newValue
      e.target.value = newValue;
      e.target.name = name;
      onChange(e, type)
    }
  }

  const onSubtractClick = (e) => {
    e.preventDefault();

    const value = inputRef.current.valueAsNumber
    const newValue = value - 1
    if (newValue >= minNumber) {
      inputRef.current.value = newValue
      e.target.value = newValue;
      e.target.name = name;
      onChange(e, type)
    }
  }
  return (
    <div className={`px-4 sm:px-6 pt-3 flex ${type !== "number" ? "flex-col" : ""} justify-between`}>
      <span className="flex-grow flex flex-col justify-center" id="availability-label">
        <span className="text-sm font-medium text-gray-500">{label}</span>
      </span>
      <div className="mt-1 relative rounded-md shadow-sm">
        {
          prefix &&
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">
              {prefix}
            </span>
          </div>
        }

        <input
          type={type || "text"}
          name={name}
          value={value}
          disabled={disabled}
          className={`focus:ring-gray-400 focus:border-gray-400 block w-48 ${prefix ? 'pl-7 ' : ''} ${suffix ? 'pr-12 ' : ''} sm:text-sm border-gray-300 rounded-md w-full`}
          onKeyDown={minNumberVerification && maxNumberVerification ? blockInvalidChar : undefined}
          onChange={(e) => handleOnChange(e, type)}
          min={minNumber}
          max={maxNumber}
          ref={inputRef}
        />
        {
          type === "number" &&
            <div className={"input-number-buttons"}>
              <button onClick={(e) => onIncrementClick(e)}>
                <FontAwesomeIcon icon={faChevronUp}/>
              </button>
              <button onClick={(e) => onSubtractClick(e)}>
                <FontAwesomeIcon icon={faChevronDown}/>
              </button>
            </div>
        }
        {
          suffix &&
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm" id="price-currency">
              {suffix}
            </span>
          </div>
        }

      </div>
    </div>
  );
}